// @flow
import styled, { css } from 'styled-components';
import { space } from 'styled-system';
import { breakpoints, colors } from '../theme';

const getStyle = (style: 'default' | 'modal') => {
  if (style === 'modal') {
    return css`
      padding: 16px 16px;
      @media (min-width: ${breakpoints[2]}) {
        padding: 25px 25px;
      }
    `;
  }
  return css`
    padding: 16px 24px;
    @media (min-width: ${breakpoints[2]}) {
      padding: 24px 32px;
    }
  `;
};

const getBorder = (type: ?('info' | 'warning' | 'danger')) => {
  if (!type) {
    return null;
  }
  let color = colors.waterBlue;

  if (type === 'warning') {
    color = colors.dandelion;
  } else if (type === 'danger') {
    color = colors.scarlet;
  }
  return css`
    border-left: solid 4px ${color};
  `;
};

const InfoBox = styled.div`
  border-radius: 4px;
  background-color: ${colors.offWhite};
  ${props => getStyle(props.boxStyle)};
  ${props => props.type && getBorder(props.type)};
  ${space};
`;

export default InfoBox;
